import React from 'react';
import { useSelector } from 'react-redux';
import PerformanceHistory from 'components/performance/PerformanceHistory';
import PlayPerformanceHistory from 'components/play/PlayPerformanceHistory';

/**
 * Punto de entrada de "Mi rendimiento" del cliente. Para OTRIX Play muestra los resultados
 * auto-reportados (C9); el resto de clientes ve el historial de rendimientos del entrenador.
 */
function ClientPerformanceEntry() {
  const isOtrixPlay = useSelector((state) => state.auth.user?.platform) === 'otrix_play';
  return isOtrixPlay ? <PlayPerformanceHistory /> : <PerformanceHistory />;
}

export default ClientPerformanceEntry;
